import { BaseError } from "./BaseError.ts";

export class ThrottledError extends BaseError {
  public override readonly name = "ThrottledError";
}
